// Hebrew relative-time formatter matching the FocusMode brand-voice spec:
//   "לפני 4 דק׳" · "לפני שעה" · "אתמול 17:30" · etc.

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function pad2(n: number): string {
  return n < 10 ? '0' + String(n) : String(n);
}

function isSameDay(a: Date, b: Date): boolean {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function formatHebrewRelative(iso: string): string {
  try {
    const date = new Date(iso);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    if (diffMs < 30 * 1000 && diffMs > -30 * 1000) return 'עכשיו';

    if (diffMs < 0) {
      return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)} ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
    }

    if (diffMs < MINUTE) return 'לפני פחות מדק׳';

    if (diffMs < HOUR) {
      const mins = Math.floor(diffMs / MINUTE);
      if (mins === 1) return 'לפני דק׳';
      return `לפני ${String(mins)} דק׳`;
    }

    if (diffMs < DAY) {
      const hrs = Math.floor(diffMs / HOUR);
      if (hrs === 1) return 'לפני שעה';
      if (hrs === 2) return 'לפני שעתיים';
      return `לפני ${String(hrs)} שעות`;
    }

    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    if (isSameDay(date, yesterday)) {
      return `אתמול ${pad2(date.getHours())}:${pad2(date.getMinutes())}`;
    }

    if (diffMs < 7 * DAY) {
      const days = Math.floor(diffMs / DAY);
      if (days === 2) return 'שלשום';
      return `לפני ${String(days)} ימים`;
    }

    return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)}`;
  } catch {
    return iso;
  }
}

export function hebrewDaysWord(days: number): string {
  if (days === 1) return 'יום';
  if (days === 2) return 'יומיים';
  return `${String(days)} ימים`;
}
